import dxDataGrid from 'devextreme/ui/data_grid';
import { EventInfo, trigger } from 'devextreme/events';

export const useOnContentReady = <TData>(
  onFocusedRowChanged?: (data: TData | null) => void,
  onSelectedRowsChanged?: (data: TData[]) => void,
  initSelectedRowKeys?: (string | number)[],
) => {
  const onContentReady = (e: EventInfo<dxDataGrid<any, any>>) => {
    if (e.component) {
      if (!e.component.totalCount()) {
        onFocusedRowChanged?.(null);
        onSelectedRowsChanged?.([]);

        return;
      } // if

      if (initSelectedRowKeys) {
        e.component.selectRows(initSelectedRowKeys, false);
      }

      // Select first row if selected rows empty
      if (!(e.component as any).isNotFirstLoad) {
        (e.component as any).isNotFirstLoad = true;

        const rows = e.element?.querySelectorAll('.dx-data-row');
        setTimeout(() => trigger(rows[0], 'dxclick'));
      }
    } // if
  };

  return {
    onContentReady,
  };
};
